import { getCurrentRegionUrl } from './getCurrentRegionUrl';

export const addCityToPath = (currentPath: string) => {
  const cityUrl = getCurrentRegionUrl();

  return (cityUrl + currentPath).replace(/\/\//g, '/');
};
